import React from 'react'
import "./WinnerBlueLan.css";
import cityImg from "../../../Images/city-skyline.jpg";
import heroImg from "../../../Images/hero-villa.jpg";
import towerImg from "../../../Images/property-tower.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
// import { WinnersAboutBlue, WinnersCitiesBlue, WinnersFAQBlue, WinnersFooterBlue, WinnersHeaderBlue, WinnersInsightsBlue, WinnersStatsBlue, WinnersTestimonialsBlue, WinnersTopProjectsBlue, WinnersUpcomingBlue, WinnersWallOfFameBlue } from '../NewHome2/Homelan';
import { WinnersBannerBlue } from './WinnerBannerBlue';
import { WinnersHeaderBlue } from './WinnersHeaderBlue';
import { WinnersStatsBlue } from './WinnersStatsBlue';
import { WinnersCitiesBlue } from './WinnersCitiesBlue';
import { WinnersInsightsBlue } from './WinnersInsightsBlue';
import { WinnersTopProjectsBlue } from './WinnersTopProjectsBlue';
// import { WinnersUpcomingBlue } from './WinnersUpcomingBlue';
import { WinnersAboutBlue } from './WinnersAboutBlue';
import { WinnersWallOfFameBlue } from './WinnersWallOfFameBlue';
import { WinnersTestimonialsBlue } from './WinnersTestimonialsBlue';
import { WinnersFAQBlue } from './WinnersFAQBlue';
import { WinnersFooterBlue } from '../../../Layout/WinnersFooterBlue';
import NewUpcomingsProjectsBlue from './NewUpcomingsProjectsBlue';
// import { WinnersAbout } from '../WinnerLand/WinnersAbout';
import { positions } from 'react-alert';


import { useEffect, useState } from "react";
import logo2 from "../../../Images/Group 1171279193.png";
import logo3 from "../../../Images/darklogo.png";
import {
  Moon,
  Sun,
  Menu,
  ChevronDown,
  X,
} from "lucide-react";
// import "./WinnersLand.css";
// import { useTheme, useCountUp } from "../WinnerLand/useTheme";
import WallofFameBlue from './WallofFameBlue';
import WinnersHomeCitiesBlue from './WinnersHomeCitiesBlue';
import DownloadAppBlue from './DownloadAppBlue';
import WallofFame from '../WallofFame';
import FutureDeveloper from '../FutureDeveloper';
import AdvertisingBanner from '../../CityPage/AdvertisingBanner';
import DownloadApp from '../DownloadApp';
import WhatsAppButton from '../../../Component/WhatsAppButton';
import CallUsButton from "../../../Component/CallUsButton";


function WinnerBlueLan() {

  // const { dark, toggle } = useTheme();
  const cityData = [
    {
      name: "Gurgaon",
      tag: "NCR",
      count: "1240",
      img: cityImg,
    },
    {
      name: "Lucknow",
      tag: "UP",
      count: "980",
      img: heroImg,
    },
    {
      name: "Noida",
      tag: "NCR",
      count: "1560",
      img: towerImg,
    },
    {
      name: "Dwarka",
      tag: "Delhi",
      count: "890",
      img: interiorImg,
    },
  ];

  const allowedCitiesOne = [" Allahabad", "Lucknow", "Dwarka", "Kanpur Nagar", "Calcutta", "Goa"];
  const allowedCitiesTwo = [
    "Gurgaon",
    "Faridabad",
    "South Delhi",
    "West Delhi",
    "East Delhi",
    "Central Noida",
    "Greater Noida",
    "Indirapuram",
    "Noida Extension",
  ];
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])


  return (
    <div style={{ positions: "relative" }}>
      {/* <button className="wsh-theme-btn_blue" onClick={toggle} aria-label="Toggle theme">
        {dark ? <Sun size={18} /> : <Moon size={18} />}
      </button> */}
      <WinnersHeaderBlue />
      {/* <WinnersBannerBlue /> */}
       <WhatsAppButton phoneNumber="918009903561" textMessge="Hello" />
       <CallUsButton/>
      <AdvertisingBanner />
      <WinnersStatsBlue />
      <WinnersCitiesBlue
        eyebrow="Popular Cities"
        title="Explore Top Locations"
        description="Discover premium properties in India's fastest growing cities."
        cities={cityData}
      />
      <WinnersInsightsBlue />
      <WinnersTopProjectsBlue />
      {/* <WinnersUpcomingBlue /> */}
      <NewUpcomingsProjectsBlue />
      <FutureDeveloper />
      <WinnersAboutBlue />
      {/* <WinnersAbout/> */}
      {/* <WinnersWallOfFameBlue /> */}
      {/* <WallofFameBlue /> */}
      <WallofFame />
      <WinnersHomeCitiesBlue
        allowedCities={allowedCitiesTwo}
        title={"Working in cities"}
        cities={cityData}
      />
      <WinnersTestimonialsBlue />
      <WinnersFAQBlue />
      {/* <DownloadAppBlue /> */}
      <DownloadApp/>
      {/* <WinnersFooterBlue /> */}


    </div>
  );

}

export default WinnerBlueLan